module.exports = __webpack_public_path__ + "static/media/picto-respect.d8f324e3.svg";